// import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

// interface AuthState {
//     step: 'mobile' | 'otp' | 'register' | 'home';
//     selectedRole: string;
//     mobile: string;
//     otp: string[];
//     isAuthenticated: boolean;
//     userExists: boolean | null;
// }

// const initialState: AuthState = {
//     step: 'mobile',
//     selectedRole: 'admin',
//     mobile: '',
//     otp: ['', '', '', ''],
//     isAuthenticated: false,
//     userExists: null,
// };

// const authSlice = createSlice({
//     name: 'auth',
//     initialState,
//     reducers: {
//         setRole: (state, action: PayloadAction<string>) => {
//             state.selectedRole = action.payload;
//         },
//         setMobile: (state, action: PayloadAction<string>) => {
//             state.mobile = action.payload;
//         },
//         setOtp: (state, action: PayloadAction<string[]>) => {
//             state.otp = action.payload;
//         },
//         setStep: (state, action: PayloadAction<AuthState['step']>) => {
//             state.step = action.payload;
//         },
//         rehydrateAuth: (state) => {
//             state.otp = ['', '', '', '', '', ''];
//         },
//         verifyOtpSuccess: (state, action: PayloadAction<{ exists: boolean }>) => {
//             state.isAuthenticated = true;
//             state.userExists = action.payload.exists;
//             if (action.payload.exists) {
//                 state.step = 'home';
//             } else {
//                 state.step = 'register';
//             }
//         },
//         resetAuth: () => initialState,
//     },
// });

// export const { setRole, setMobile, setOtp, setStep, verifyOtpSuccess, resetAuth, rehydrateAuth } = authSlice.actions;
// export default authSlice.reducer;

// core/store/authSlice.ts

// import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

// interface AuthState {
//     step: 'mobile' | 'otp' | 'register' | 'home';
//     selectedRole: string;
//     mobile: string;
//     otp: string[];
//     isAuthenticated: boolean;
//     userExists: boolean | null;
// }

// const initialState: AuthState = {
//     step: 'mobile',
//     selectedRole: 'admin',
//     mobile: '',
//     otp: ['', '', '', ''],
//     isAuthenticated: false,
//     userExists: null,
// };

// const authSlice = createSlice({
//     name: 'auth',
//     initialState,
//     reducers: {
//         setRole: (state, action: PayloadAction<string>) => {
//             state.selectedRole = action.payload;
//         },
//         setMobile: (state, action: PayloadAction<string>) => {
//             state.mobile = action.payload;
//         },
//         setOtp: (state, action: PayloadAction<string[]>) => {
//             state.otp = action.payload;
//         },
//         setStep: (state, action: PayloadAction<AuthState['step']>) => {
//             state.step = action.payload;
//         },
//         rehydrateAuth: (state) => {
//             state.otp = ['', '', '', ''];
//         },
//         verifyOtpSuccess: (state, action: PayloadAction<{ exists: boolean }>) => {
//             state.isAuthenticated = true;
//             state.userExists = action.payload.exists;
//             if (action.payload.exists) {
//                 state.step = 'home';
//             } else {
//                 state.step = 'register';
//             }
//         },
//         resetAuth: () => initialState,
//     },
// });

// export const { setRole, setMobile, setOtp, setStep, verifyOtpSuccess, resetAuth, rehydrateAuth } = authSlice.actions;
// export default authSlice.reducer;

// import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

// interface AuthState {
//     step: 'mobile' | 'otp' | 'register' | 'home';
//     selectedRole: string;
//     mobile: string;
//     otp: string[];
//     isAuthenticated: boolean;
//     userExists: boolean | null;
//     referralCode: string;      // اضافه شد
//     referralName: string;      // اضافه شد
// }

// const initialState: AuthState = {
//     step: 'mobile',
//     selectedRole: 'admin',
//     mobile: '',
//     otp: ['', '', '', ''],
//     isAuthenticated: false,
//     userExists: null,
//     referralCode: '',          // مقدار اولیه
//     referralName: '',          // مقدار اولیه
// };

// const authSlice = createSlice({
//     name: 'auth',
//     initialState,
//     reducers: {
//         setRole: (state, action: PayloadAction<string>) => {
//             state.selectedRole = action.payload;
//         },
//         setMobile: (state, action: PayloadAction<string>) => {
//             state.mobile = action.payload;
//         },
//         setOtp: (state, action: PayloadAction<string[]>) => {
//             state.otp = action.payload;
//         },
//         setStep: (state, action: PayloadAction<AuthState['step']>) => {
//             state.step = action.payload;
//         },
//         rehydrateAuth: (state) => {
//             state.otp = ['', '', '', ''];
//         },
//         verifyOtpSuccess: (state, action: PayloadAction<{ exists: boolean }>) => {
//             state.isAuthenticated = true;
//             state.userExists = action.payload.exists;
//             if (action.payload.exists) {
//                 state.step = 'home';
//             } else {
//                 state.step = 'register';
//             }
//         },
//         // ===== اکشن‌های جدید برای کد معرف =====
//         setReferralCode: (state, action: PayloadAction<string>) => {
//             state.referralCode = action.payload;
//         },
//         setReferralName: (state, action: PayloadAction<string>) => {
//             state.referralName = action.payload;
//         },
//         clearReferralData: (state) => {
//             state.referralCode = '';
//             state.referralName = '';
//         },
//         resetAuth: () => initialState,
//     },
// });

// export const { 
//     setRole, 
//     setMobile, 
//     setOtp, 
//     setStep, 
//     verifyOtpSuccess, 
//     resetAuth, 
//     rehydrateAuth,
//     setReferralCode,      // export جدید
//     setReferralName,      // export جدید
//     clearReferralData,    // export جدید
// } = authSlice.actions;

// export default authSlice.reducer;


import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface AuthState {
    step: 'mobile' | 'otp' | 'register' | 'home';
    selectedRole: string;
    mobile: string;
    otp: string[];
    isAuthenticated: boolean;
    userExists: boolean | null;
    referralCode: string;
    referralName: string;
    shouldResetMobile: boolean; // ✅ اضافه شد
}

const initialState: AuthState = {
    step: 'mobile',
    selectedRole: 'admin',
    mobile: '',
    otp: ['', '', '', ''],
    isAuthenticated: false,
    userExists: null,
    referralCode: '',
    referralName: '',
    shouldResetMobile: false, // ✅ اضافه شد
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setRole: (state, action: PayloadAction<string>) => {
            state.selectedRole = action.payload;
        },
        setMobile: (state, action: PayloadAction<string>) => {
            state.mobile = action.payload;
        },
        setOtp: (state, action: PayloadAction<string[]>) => {
            state.otp = action.payload;
        },
        setStep: (state, action: PayloadAction<AuthState['step']>) => {
            state.step = action.payload;
        },
        rehydrateAuth: (state) => {
            state.otp = ['', '', '', ''];
        },
        verifyOtpSuccess: (state, action: PayloadAction<{ exists: boolean }>) => {
            state.isAuthenticated = true;
            state.userExists = action.payload.exists;
            if (action.payload.exists) {
                state.step = 'home';
            } else {
                state.step = 'register';
            }
        },
        setReferralCode: (state, action: PayloadAction<string>) => {
            state.referralCode = action.payload;
        },
        setReferralName: (state, action: PayloadAction<string>) => {
            state.referralName = action.payload;
        },
        clearReferralData: (state) => {
            state.referralCode = '';
            state.referralName = '';
        },
        setShouldResetMobile: (state, action: PayloadAction<boolean>) => {
            state.shouldResetMobile = action.payload;
        },
        resetAuth: () => initialState,
        // ✅ ریست کردن فقط برای خروج موفق
        resetAuthForLogout: () => ({
            ...initialState,
            shouldResetMobile: true, // علامت بزن که شماره پاک بشه
        }),
    },
});

export const { 
    setRole, 
    setMobile, 
    setOtp, 
    setStep, 
    verifyOtpSuccess, 
    resetAuth, 
    rehydrateAuth,
    setReferralCode,
    setReferralName,
    clearReferralData,
    setShouldResetMobile,
    resetAuthForLogout,
} = authSlice.actions;

export default authSlice.reducer;